/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FC, ChangeEvent, useContext, useState,
} from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { useQuery } from '@apollo/react-hooks';
import { getItem, saveItem } from '@/utils';
import { STORAGE_KEY_CURRENT_DOMAIN } from '@/constants/storage';
import { UserContext } from '@/providers/UserProvider';
import { GET_USER_INFO } from '@/gql/query/common';
import get from 'lodash/get';
import useStyles from './styles';

const DomainChange: FC = () => {
  const classes = useStyles();
  const { user } = useContext(UserContext);
  const [domain, setDomain] = useState<string>(getItem(STORAGE_KEY_CURRENT_DOMAIN, false) || 'all');
  const { data: userData } = useQuery(GET_USER_INFO, {
    skip: !user?.email,
  });
  const domains = get(userData, 'getUserInfo.payload.node.domains') || [];

  return (
    <TextField
      autoComplete="off"
      size="small"
      select
      variant="filled"
      label="Select PTP Client / Partner:"
      className={classes.select}
      onChange={(e) => handleChange(e as ChangeEvent<HTMLInputElement>)}
      value={domain}
    >
      <MenuItem value="all"><em>All</em></MenuItem>
      {domains && domains.map((item: any) => (
        <MenuItem key={item?.id} value={item?.name || ''}>{item?.name || ''}</MenuItem>
      ))}
    </TextField>
  );

  async function handleChange({ target: { value } }: ChangeEvent<HTMLInputElement>) {
    saveItem(STORAGE_KEY_CURRENT_DOMAIN, value || '', false);
    setDomain(value);
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};

export default DomainChange;
